import { Box, Heading } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDashboard } from '../../actions'
import { currentAdminPropTypes } from '../../reducers/adminsReducer'
import { agencyPropTypes } from '../../reducers/agenciesReducer'
import DashboardAgency from './Dashboard.Agency'
import DashboardOrganization from './Dashboard.Organization'
import DashboardSkeleton from './Dashboard.Skeleton'

/**
 * Dashboard component
 *
 * This component is responsible for displaying the dashboard.
 *
 * @param {Object} props - The properties of the component
 * @param {Function} props.fetchDashboard - The function to fetch the dashboard
 * @param {import('../../reducers/adminsReducer').CurrentAdmin} props.currentAdmin - The current admin object
 * @param {import('../../reducers/dashboardReducer').DashboardState} props.dashboard - The dashboard object
 * @param {import('../../reducers/agenciesReducer').CurrentAgency} props.currentAgency - The current agency object
 *
 * @returns {JSX.Element}
 */
const Dashboard = () => {
  const dispatch = useDispatch()
  const { currentAdmin, currentAgency } = useSelector(state => ({
    currentAdmin: state.admins.current_admin,
    currentAgency: state.current.agency
  }))

  useEffect(() => {
    if (currentAgency?.id) {
      dispatch(fetchDashboard())
    }
  }, [dispatch, currentAgency?.id])

  const showDashboard = !(currentAdmin.is_client_admin || !currentAdmin || !currentAdmin.id)

  if (!currentAdmin) {
    return <DashboardSkeleton />
  }

  return (
    <div className="animated fadeIn">
      <Box mb={16}>
        <Heading as="h1" size="xl">
          Welcome Back, {currentAdmin.name}
        </Heading>
      </Box>
      {showDashboard && currentAdmin.logged_in_as === 'Organization' && <DashboardOrganization />}
      {showDashboard && currentAdmin.logged_in_as === 'Agency' && <DashboardAgency />}
    </div>
  )
}

Dashboard.propTypes = {
  fetchDashboard: PropTypes.func.isRequired,
  currentAdmin: currentAdminPropTypes,
  currentAgency: agencyPropTypes
}

export default Dashboard
